<div class="sec-title">
  <h1>Clients</h1>
</div>
<div class="search-box container d-flex justify-content-end">
  <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
    
  </div>
</div>

<ul class="editing-list list-group">
  <li class="list-group-item list-group-header">
    <div class="card">
      <div class="row col-lg-12">
        <div class="col-lg-8 col-md-12 mt-4">
          <a class="btn btn-success btn-action" href="/ajouter-client" routerLink="/ajouter-client" role="button"><i class="bi bi-plus-circle"></i> client</a>
        </div>
        <div class="col-lg-1 col-md-4 mt-4">
          <a class="btn btn-action btn-filter" [ngClass]="{'selected_filter': filter=='all'}" (click)="changeFilter('all')" role="button"> Toutes</a>
        </div>
        <div class="col-lg-3 col-md-12 align-text-bottom header-action-btn">
            <form [formGroup]="searchClientForm" (ngSubmit)="onSubmit(searchClientForm.value)" novalidate>
              <div class="form-group input-group mb-3">
                <label for="search_client" class="visually-hidden">Recherche</label>
                <input type="text" class="form-control" name="search_client" id="search_client" formControlName="search_client" placeholder="Recherche...">
                <span class="form-control-clear glyphicon glyphicon-remove form-control-feedback"></span>
                <div class="input-group-append">
                  <button type="submit" class="input-group-text right-action-btn">
                    <i title="Recherche" class="bi bi-search"></i>
                  </button>
                </div>
              </div>
            </form>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-lg-11 col-md-11">
                <div class="row">
                  <div class="col-lg-1 col-md-3">Langue</div>
                  <div class="col-lg-3 col-md-9">Client</div>
                  <div class="col-lg-3 col-md-12">Addresse de la soumission</div>
                  <div class="col-lg-4 col-md-12">Soumissions</div>
                </div>
              </div>
              <div class="col-md-1 d-flex justify-content-end action-icons">
                <div>Modifier</div>
              </div>
          </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="total === 0 && isSearch == true">
    <div class="card">
      <div class="card-body">
        <div class="row mt-3 ms-3 mb-3 strong">
              {{no_results_message}}
        </div>
      </div>
    </div>
  </li>
  <li *ngIf="diplay_loading != '' && isSearch == false; else Results" class="list-group-item">
    <div class="card">
      <div class="card-body">  
        <div class="mt-3 ms-3 mb-3 strong">
          {{ diplay_loading }} 
          <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
          <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
          <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  </li>
  <ng-template #Results>
    <li class="list-group-item" *ngFor="let client of clientInfo | paginate: { itemsPerPage: 10, currentPage: p+1, totalItems: total}; let i = index">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-1">
                  <p class="card-title">{{client.client_language_code}}</p>
                </div>
                <div class="col-md-3">
                  <span class="card-title card-title-main">({{client.client_gender}}) {{client.client_fname}} {{client.client_lname}}</span>
                  <div class="card-subtitle text-muted">
                    <span>
                      {{client.client_address}} {{client.client_address2}},
                      {{client.client_city}} {{client.client_province}} {{client.client_postalcode}}
                    </span>
                  </div>
                </div>
                <div class="col-md-7">
                  <div *ngFor="let clientSubmisison of client.submissions; let i = index">
                    <ng-container>
                      <div class="card-text mb-2" >
                        <div class="col-lg-6 col-md-12 float-lg-start">
                            <span class="txt-strong" [ngClass]="{'submisison_refused' : clientSubmisison.is_refused }">
                                  {{clientSubmisison.address}} {{clientSubmisison.address2}},
                                  {{clientSubmisison.city}} {{clientSubmisison.province}} {{clientSubmisison.postalcode}}
                            </span>
                        </div>
                        <div class="col-lg-6 col-md-12 float-lg-start">
                          <a  *ngIf="!isForeman" href="/soumission/{{clientSubmisison.submission_id}}/editer"><i class="bi bi-link"></i>soumission #{{clientSubmisison.submission_no}}</a>
                      </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1 d-flex justify-content-end action-icons">
              <a *ngIf="!isForeman" routerLink="/ajouter-soumission/{{client.client_id}}/ajouter" class="card-link"><button type="button" class="btn btn-outline-secondary left-action-btn add-btn"><i class="bi bi-file-earmark-plus" data-toggle="tooltip" data-placement="top" title="Ajouter une soumission"></i></button></a>
              <a *ngIf="!isForeman" href="javascript:void(0);" (click)="deleteClient(client.client_id, client.client_fname, client.client_lname, client.client_updated)" role="button" class="card-link"><button type="button" class="btn btn-outline-secondary middle-action-btn btn-action-delete"><i class="bi bi-x-circle-fill"  data-toggle="tooltip" data-placement="top" title="Supprimer le client"></i></button></a>
        
              <a routerLink="/client/{{client.client_id}}/editer" class="card-link"><button type="button" class="btn btn-outline-secondary right-action-btn"><i class="bi bi-pencil-square"  data-toggle="tooltip" data-placement="top" title="Modifier le client"></i></button></a>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ng-template>
</ul>

<pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>

<div id="clientModal" class="modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Supprimer</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
      </div>
      <div class="modal-body">
        <p>Êtes-vous sûr de vouloir supprimer ce client ?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        <button type="button" class="btn btn-danger">Effacer</button>
      </div>
    </div>
  </div>
</div>